// ==========================================
// Buddy markdown — the small subset the chat log renders (3d COMPONENTS)
// ==========================================
// "md: bold/list/code/link" is all the spec asks for, so this stays deliberately
// tiny rather than pulling a markdown library into the ERP bundle.
//
// Input is escaped before any markup is introduced, so the SafeHtml handed back
// can only ever contain the tags produced here — model output cannot inject HTML.
// ==========================================

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

const ORDERED_LINE = /^(\d+)\.\s+(.*)$/;

function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Applied only to already-escaped text. */
function inline(escaped: string): string {
  return (
    escaped
      // `code`
      .replace(/`([^`]+)`/g, '<code class="md__code">$1</code>')
      // **bold**
      .replace(/\*\*([^*]+)\*\*/g, '<strong class="md__strong">$1</strong>')
      // [label](href) — href is restricted to http(s) to keep javascript: out.
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a class="md__link" href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
  );
}

@Pipe({ name: 'buddyMarkdown', standalone: false })
export class BuddyMarkdownPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const html = value
      .split('\n')
      .map((line) => {
        const escaped = escapeHtml(line);
        const ordered = ORDERED_LINE.exec(escaped);
        if (ordered) {
          return `<span class="md__item"><span class="md__index">${ordered[1]}.</span><span>${inline(
            ordered[2]
          )}</span></span>`;
        }
        return `<span class="md__line">${inline(escaped)}</span>`;
      })
      .join('');

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
